export function createElement(assetsToBeLoaded) {
  return assetsToBeLoaded.map(({
    type, src, defer,
    width = 1, height = 1,
    style = '', border = 1,
    alt = '',
  }) => {
    let element = {};
    return new Promise((resolve) => {
      switch (type) {
        case 'script':
          element = document.createElement('script');
          element.src = src;
          element.type = 'text/javascript';
          element.async = false;
          element.defer = defer;
          element.charset = 'UTF-8';
          element.onload = _elem => resolve(_elem);
          document.body.appendChild(element);
          break;
        case 'link':
          element = document.createElement('link');
          element.href = src;
          element.rel = 'stylesheet';
          element.async = false;
          element.defer = defer;
          element.onload = _elem => resolve(_elem);
          document.head.appendChild(element);
          break;
        case 'img':
          element = document.createElement('img');
          element.src = src;
          element.style = style;
          element.width = width;
          element.height = height;
          element.border = border;
          element.alt = alt;
          element.onload = _elem => resolve(_elem);
          document.body.appendChild(element);
          break;
        default: break;
      }
    });
  });
}

export async function injectOtherScripts() {
  let assetsToBeLoaded = [];

  if (
    document.querySelectorAll('.slider')
    && !document.querySelector("script[src='/assets/dest/js/slider.js?v=9']")
    // Pages that already load the webpack-built slider bundle explicitly
    // (e.g. via assets.getString("slider.js")) don't need this legacy one —
    // loading both double-initializes any swiper the page already has.
    && !document.querySelector('script[src*="/assets/build/slider."]')
  ) {
    assetsToBeLoaded = assetsToBeLoaded.concat([{ type: 'script', src: '/assets/dest/js/slider.js?v=9', defer: true }]);
  }

  if (document.querySelector('.showMorePlansBtn') && !document.querySelector("script[src='/assets/dest/js/plansHelper.js']")) {
    assetsToBeLoaded = assetsToBeLoaded.concat([{ type: 'script', src: '/assets/dest/js/plansHelper.js', defer: true }]);
  }

  if (document.getElementById('audioPlayer') && !document.querySelector("script[src='/assets/dest/js/audioPlayer.js?v=1']")) {
    assetsToBeLoaded = assetsToBeLoaded.concat([{ type: 'script', src: '/assets/dest/js/audioPlayer.js?v=1', defer: true }]);
  }

  if (document.getElementById('videoPreview') && !document.querySelector("script[src='/assets/dest/js/videoPlayer.js?v=4']")) {
    assetsToBeLoaded = assetsToBeLoaded.concat([{ type: 'script', src: '/assets/dest/js/videoPlayer.js?v=4', defer: true }]);
  }

  if (assetsToBeLoaded.length > 0) {
    const isAppened = await Promise.all(createElement(assetsToBeLoaded)).then(() => true);
    return isAppened;
  }
  return true;
}

export default async function injectRegistrationScripts() {
  if ((document.getElementById('registration') || document.getElementById('demo-registration')) && !document.querySelector("script[src='https://storage.googleapis.com/clientaccess/registration/InputValidator.js']")) {
    const assetsToBeLoaded = [{ type: 'link', src: 'https://storage.googleapis.com/clientaccess/registration/IntlTelInput/intlInput.css', defer: true },
      { type: 'script', src: 'https://storage.googleapis.com/clientaccess/registration/InputValidator.js', defer: true },
      { type: 'script', src: 'https://storage.googleapis.com/branding-resources/tz-moment.js', defer: true },
      { type: 'script', src: 'https://storage.googleapis.com/clientaccess/registration/IntlTelInput/intlTelInputUtils.js', defer: true }];

    if (document.getElementById('registration') && !document.querySelector(`script[src='${window.registrationHelperScriptLink}']`)) {
      assetsToBeLoaded.push({ type: 'script', src: window.registrationHelperScriptLink, defer: true });
    }
    if (document.getElementById('demo-registration') && !document.querySelector(`script[src='${window.demoRegisterScripLink}']`)) {
      assetsToBeLoaded.push({ type: 'script', src: window.demoRegisterScripLink, defer: true });
    }
    const isAppend = await Promise.all(createElement(assetsToBeLoaded)).then(() => true);
    return isAppend;
  }
  return true;
}
